/* eslint-disable @typescript-eslint/no-shadow */
import { handle } from 'redux-pack';
import {
	SET_HOME_ROUTE,
	SET_HOME_CHANNEL,
	LOAD_NOTIFICATIONS,
	SET_HOME_MEETING,
	LOAD_TEAMS,
} from '../actions/home';
import { Action } from '../types/types';
import { ICONS } from '../../components/general-components/icon';
import { decodeHtmlEntities } from '../../utils/utils';
import type {
	Channel,
	HomeNotification,
	TeamMember,
	ChannelTeam,
	HomeState,
} from '../types/home';

export const NOTIFICATION_TYPES = {
	COMMENT_BASIC: 'comment-basic',
	COMMENT_MENTION: 'comment-mention',
	INVITE_PRESENTER: 'invite-presenter',
	INVITE_VIEWER: 'invite-viewer',
	REHEARSAL_CREATE: 'rehearsal-create',
	TECHCHECK_CREATE: 'techcheck-create',
	DOWNLOAD_READY: 'download-ready',
};

interface homeRoutes {
	[key: string]: number;
}

export const HOME_ROUTES: homeRoutes = {
	SHOWS: 1,
	TEMPLATES: 2,
	TEAM: 3,
	SETTINGS: 4,
	DETAILS: 5,
};

interface homeRouteIcons {
	[key: string]: string;
}

export const HOME_ROUTE_ICONS: homeRouteIcons = {
	SHOWS: ICONS.CALENDAR,
	TEMPLATES: ICONS.TEMPLATES,
	TEAM: ICONS.PRESENTERS,
	SETTINGS: ICONS.SETTINGS,
};

export const initialHomeState: HomeState = {
	currentRoute: HOME_ROUTES.SHOWS,
	selectedChannel: null,
	notifications: [],
	homeMeeting: null,
	teams: [],
	teamsLoading: false,
	teamsLoaded: false,
};

const actions: Map<string, Function> = new Map([
	[SET_HOME_ROUTE, (state: HomeState, action: Action): HomeState => (
		{ ...state, currentRoute: action.payload }
	)],
	[LOAD_NOTIFICATIONS, (state: HomeState, action: Action): HomeState => handle(state, action, {
		success: (state) => ({ ...state, notifications: action.payload, notificationsLoaded: true }),
		failure: (state) => ({ ...state, notifications: action.payload, notificationsLoaded: false }),
		start: (state) => ({ ...state, notificationsLoading: true }),
		finish: (state) => ({ ...state, notificationsLoading: false }),
	})],
	[LOAD_TEAMS, (state: HomeState, action: Action): HomeState => handle(state, action, {
		success: (state) => ({ ...state, teams: action.payload, teamsLoaded: true }),
		failure: (state) => ({ ...state, teams: action.payload, teamsLoaded: false }),
		start: (state) => ({ ...state, teamsLoading: true }),
		finish: (state) => ({ ...state, teamsLoading: false }),
	})],
	[SET_HOME_CHANNEL, (state: HomeState, action: Action): HomeState => (
		{ ...state, selectedChannel: action.payload }
	)],
	[SET_HOME_MEETING, (state: HomeState, action: Action): HomeState => {
    	return {
        	...state,
        	homeMeeting: action.payload
            ? { ...action.payload, title: decodeHtmlEntities(action.payload.title) }
            : action.payload,
    	};
	}],
]);

// eslint-disable-next-line default-param-last
export function HomeReducer(state: HomeState = initialHomeState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}
